import { Grid, Box, Divider, Typography, IconButton } from '@mui/material'
import React, { useEffect, useState, useContext } from 'react'
import DefaultPainel from '../../components/shared/Painel'
import TableExemplares from './components/TableExemplares'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import BaseFilter from '../../components/BaseFilter'
import FormExemplar from './components/FormExemplar'
import { useParams } from 'react-router-dom'
import PrivateRC from '../../components/PrivateRC'
import TableHeader from '../../components/shared/tables/TableHeader'
import EditExemplar from './components/EditExemplar'
import { PermissionsContext } from '../../providers/permissions'
import gerarPaginacao from '../../services/pagination'
import { DeleteForever } from '@mui/icons-material'
import { confirmDelete } from '../livros/functions'
import Exemplares from '../../services/http/obras/Exemplares'
import filter from './filters'
import ApprovedChip from '../../components/shared/ApprovedChip'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const Exemplar = () => {
  const { hasThisPermission } = useContext(PermissionsContext)
  const [rows, setRows] = useState([])
  const [lastPage, setLastPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const { idObra, obraName } = useParams()

  const [nomeLivro, setNomeLivro] = useState('')
  const [query, setQuery] = useState({})
  const [tloading, setTloading] = useState(false)

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => buscarExemplares(query, value),
    1
  )

  const buscarExemplares = async (filters = {}, page = 1) => {
    setTloading(true)
    const { data } = await Exemplares().show({
      page,
      obra_id: idObra,
      'includes[]': 'biblioteca,formatoExemplar,statusExemplar',
      // 'includes[]':
      //   'exemplares,exemplares.formatoExemplar,exemplares.statusExemplar,exemplares.biblioteca',
      ...filters
    })
    setLastPage(data.last_page)
    setCurrentPage(data.current_page)
    setTloading(false)
    if (data.data !== undefined) {
      const exemp = data.data.map(item => {
        return {
          ...item,
          codExemplar: item.id,
          statusExemplar: item.status_exemplar.descricao,
          formatoExemplar: item.formato_exemplar.descricao,
          biblioteca: item.biblioteca.apelido
        }
      })
      setRows([...exemp])
    } else {
      setTloading(false)
      setRows([])
    }
  }

  const deleteExemplar = async id => {
    await Exemplares(id).delete(
      {},
      { notification: true, message: 'Sucesso ao remover exemplar!' }
    )

    buscarExemplares({}, currentPage)
  }

  const columns = [
    {
      field: 'codExemplar',
      headerName: 'Cód.',
      flex: 2
    },
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 2
    },
    {
      field: 'formatoExemplar',
      headerName: 'Formato',
      flex: 1.5
    },
    {
      field: 'statusExemplar',
      headerName: 'Status',
      flex: 1.5,
      renderCell: ({ row }) => {
        const status = row.statusExemplar
        return <ApprovedChip value={status} />
      }
    },
    {
      field: 'observacao',
      headerName: 'Observação',

      flex: 2
    },

    hasThisPermission({ permission: 'exemplares#update' })
      ? {
          field: 'actions',
          headerName: 'Ações',
          renderCell: ({ row }) => {
            return (
              <>
                <PrivateRC permission="exemplares#update">
                  <EditExemplar
                    dados={row}
                    idExemplar={row.id}
                    buscarExemplares={() => buscarExemplares({}, currentPage)}
                    idObra={row.obra_id}
                  />
                </PrivateRC>
                <PrivateRC permission="exemplares#delete">
                  <IconButton
                    onClick={() => {
                      const msg = `Deseja remover este exemplar?`
                      confirmDelete(row.id, 'exemplar', msg, deleteExemplar)
                    }}
                    color="error"
                  >
                    <DeleteForever />
                  </IconButton>
                </PrivateRC>
              </>
            )
          },
          flex: 1.4
        }
      : {}
  ].map(item => ({
    ...item,
    headerClassName: 'styledHeader',
    sortable: false,
    align: 'center'
  }))

  useEffect(() => {
    buscarExemplares()
  }, [])

  useEffect(() => {
    setNomeLivro(
      obraName[0]?.toUpperCase() + '' + obraName?.toLowerCase().slice(1) || ''
    )
  }, [obraName])

  return (
    <Box>
      {/* <ModalNovidades novidade="quantidade">
        <h1>Olá mundo ti</h1>
      </ModalNovidades> */}
      <PrivateRC permission="exemplares#store">
        <DefaultPainel sx={{ mt: '4vh' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              p: 0,
              mb: 2
            }}
          >
            <Typography variant="h5">Cadastrar Exemplar</Typography>
          </Box>
          <FormExemplar
            submitMethod="post"
            idObra={parseInt(idObra)}
            onSubmit={() => buscarExemplares()}
          />
        </DefaultPainel>
      </PrivateRC>

      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer rowSpacing={0}>
          <>
            <TableHeader
              titulo={'Lista de Exemplares '}
              controls={
                <MobileFilterHeaderContainer>
                  <BaseFilter
                    color="white"
                    filter={filter}
                    onChange={value => {
                      setQuery(Object.assign(query, value))
                      buscarExemplares(query)
                    }}
                  />
                </MobileFilterHeaderContainer>
              }
            />
            <Grid item xs={12} sm={12}>
              <Divider />
              <TableExemplares
                rows={rows}
                columns={columns}
                disableColumnMenu
                disableColumnSelector
                pagination={pagination}
                rowsPerPageOptions={[15]}
                pageSize={15}
                loading={tloading}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default Exemplar
